import { useTranslateCost } from "@/modules/translate/translate-cost";

const TranslateCostSymbol = () => {
  const { getCostSymbol } = useTranslateCost();

  return getCostSymbol();
};

export default TranslateCostSymbol;
